/* Comparator channel stamp (theme setting, privacy 5.16): only the comparator's name, also without consent, as a hidden
   line property of the products added and, once the cart exists, as a private cart attribute.
   The cart receipt that ran next to it with consent was retired on 24/10/2026: Shopify's own journey already covers
   the visitors who consent, and on the orders it reached it never named a channel the order lacked. */
(function () {
  'use strict';
  if (window.__sksComparatorTracker) return;
  window.__sksComparatorTracker = true;
  var entry = new URL(window.location.href), ref = '';
  try { ref = new URL(document.referrer).hostname; } catch (_) {}
  var script = document.currentScript;
  var stampOn = !!(script && script.hasAttribute && script.hasAttribute('data-channel-stamp'));
  var STAMP = '_sks_ch', CART_STAMP = '__sks_ch', stamped = false;
  // Same rules as comparators/orders.py _channel: explicit UTMs win over the referrer.
  function channelOf(source, campaign, host) {
    source = String(source || '').toLowerCase(); campaign = String(campaign || '').toLowerCase();
    function hostIs(domain) { return host === domain || host.slice(-domain.length - 1) === '.' + domain; }
    var markets = ['it', 'fr', 'de', 'at'], i;
    if (['stileo', 'glami', 'stileo.it'].indexOf(source) >= 0) return 'stileo';
    if (['trovaprezzi', 'trovaprezzi.it', 'drezzy', 'drezzy.it', '7pixel', 'shoppydoo'].indexOf(source) >= 0) return 'trovaprezzi';
    if (/^idealo([._](it|fr|de|at))?$/.test(source)) {
      for (i = 0; i < markets.length; i++) {
        var m = markets[i];
        if (source === 'idealo_' + m || source === 'idealo.' + m || campaign === 'idealo_' + m || hostIs('idealo.' + m)) return 'idealo_' + m;
      }
      return '';
    }
    if (source) return '';
    if (hostIs('stileo.it') || hostIs('glami.it')) return 'stileo';
    if (hostIs('trovaprezzi.it') || hostIs('drezzy.it') || hostIs('shoppydoo.it')) return 'trovaprezzi';
    for (i = 0; i < markets.length; i++) if (hostIs('idealo.' + markets[i])) return 'idealo_' + markets[i];
    return '';
  }
  var channel = channelOf(entry.searchParams.get('utm_source'), entry.searchParams.get('utm_campaign'), ref);
  function root() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
  function write(attributes) {
    // keepalive: a click that leaves the page must not abort the write.
    return fetch(root() + 'cart/update.js', {method: 'POST', credentials: 'same-origin', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: attributes})});
  }
  // Hidden line property: it reaches the order also through "Buy it now" and wallets, which skip the cart.
  // Only the page's main product form (buy-buttons.liquid): the clicked product, never a card's quick add.
  function stampForms() {
    if (!stampOn || !channel || typeof document.querySelectorAll !== 'function') return;
    var forms = document.querySelectorAll('form[id^="product-form-main-"][action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="properties[' + STAMP + ']"]')) continue;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[' + STAMP + ']'; input.value = channel;
      forms[i].appendChild(input);
    }
  }
  // Only after something was added: the cart (and its technical cookie) exists, so the stamp creates no cookie.
  // Private ("__"): not rendered by Liquid, so it costs the visitor no page caching.
  async function stampCart() {
    if (!stampOn || !channel || stamped) return;
    stamped = true;
    try {
      var a = {}; a[CART_STAMP] = channel;
      var r = await write(a);
      if (!r || !r.ok) stamped = false;
    } catch (_) { stamped = false; }
  }
  // A form re-rendered by the page (a variant change) gets the stamp again at the next gesture.
  function gesture(event) {
    if (!event.isTrusted || navigator.webdriver) return;
    stampForms();
  }
  stampForms();
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (name) { document.addEventListener(name, gesture, {passive: true, capture: true}); });
  // A successful add only: cart:refresh also follows a failed add, when the cart may not exist yet.
  document.addEventListener('cart:change', function (event) {
    var c = event && event.detail && event.detail.cart;
    if (!(c && c.item_count === 0)) stampCart();
  });
})();
